export default __webpack_public_path__ + "static/media/grafema_pilates_03.d7b6b230.mp4";